<div class="welcome-screen">
	<div class="welcome-content">
		<h1 class="welcome-greeting">{{ getGreeting() }}, {{ userName }}</h1>
		<p class="welcome-subtitle">How can I help you today?</p>

		<!-- Centered Welcome Input -->
		<div class="welcome-input-container">
			<div class="welcome-input-wrapper" [ngClass]="{ 'input-wrapper-disabled': isLoading || isTyping }">
				<!-- Selected file chip -->
				<div class="selected-file-chip" *ngIf="selectedFile">
					<svg-icon [src]="getFileIcon(selectedFile.name)" class="file-type-icon"></svg-icon>
					<span class="file-name">{{ selectedFile.name }}</span>
					<span class="file-size">{{ formatFileSize(selectedFile.size) }}</span>
					<button class="remove-btn" aria-label="Remove attached file" title="Remove attached file" (click)="onRemoveFile()" type="button">
						<svg-icon src="assets/icons/close-icon.svg" aria-hidden="true"></svg-icon>
					</button>
				</div>
				<textarea
					id="welcome-message-input"
					aria-label="Message DEO"
					class="welcome-textarea"
					[ngModel]="currentMessage"
					(ngModelChange)="onMessageChange($event)"
					placeholder="Message DEO..."
					(keypress)="onKeyPress($event)"
					[disabled]="isLoading"
					rows="2"
				></textarea>
				<div class="button-row" [ngClass]="{ 'button-row-disabled': isLoading || isTyping }">
					<div class="left-actions">
						<nz-upload
							*ngIf="isAttachFileEnabled"
							[nzBeforeUpload]="beforeUpload"
							[nzShowUploadList]="false"
							nzAccept=".txt,.pdf,.csv,.md"
							[nzDisabled]="isTyping || isLoading"
						>
							<button class="attach-btn" nz-button type="button" [disabled]="isTyping || isLoading" title="Attach file">
								<svg-icon src="assets/icons/attachment.svg"></svg-icon>
								<span>Attach file</span>
							</button>
						</nz-upload>

						<button
							*ngIf="isLiveTranscriptionEnabled"
							class="dictate-btn"
							[class.listening]="isListening"
							[disabled]="isTyping || isLoading"
							(click)="onVoiceToggle()"
							[title]="isListening ? 'Stop recording' : 'Start voice input'"
							[attr.aria-label]="isListening ? 'Stop recording' : 'Start voice input'"
							type="button"
						>
							<svg-icon src="assets/icons/microphone.svg"></svg-icon>
							<span class="dictate-text">{{ isListening ? 'Listening...' : 'Dictate' }}</span>
						</button>
					</div>
					<button class="welcome-send-btn" [disabled]="!currentMessage.trim() || isLoading" (click)="onSend()" aria-label="Send message">
						<svg-icon src="assets/icons/send.svg" class="send-icon" />
						Send
					</button>
				</div>
			</div>
			<div class="input-footer">
				<small class="text-muted"> DEO AI Assist is AI and can make mistakes. Please double-check responses. </small>
			</div>
		</div>
	</div>
</div>
